import React from 'react'
import { FieldGroup, LabeledToggleRow, SettingsPane, ToggleList } from '../organization-ui'
import type { OrganizationSettingsFormProps } from '../settings/organizationSettingsForm.types'

export const NotificationsPane: React.FC<OrganizationSettingsFormProps> = ({
  setValue,
  watch,
  disabled = false,
}) => (
  <SettingsPane
    title="Notifications"
    description="Channels used to deliver system notifications to your team."
  >
    <FieldGroup label="Channels">
      <ToggleList>
        <LabeledToggleRow
          label="Email notifications"
          description="Send notification updates to each recipient's email address."
          checked={watch('notificationSettings.emailEnabled') ?? false}
          disabled={disabled}
          onChange={(checked) =>
            setValue('notificationSettings.emailEnabled', checked, { shouldDirty: true })
          }
        />
        <LabeledToggleRow
          label="In-app notifications"
          description="Show notifications inside the admin workspace."
          checked={watch('notificationSettings.inAppEnabled') ?? false}
          disabled={disabled}
          onChange={(checked) =>
            setValue('notificationSettings.inAppEnabled', checked, { shouldDirty: true })
          }
        />
      </ToggleList>
    </FieldGroup>
  </SettingsPane>
)

NotificationsPane.displayName = 'NotificationsPane'
